/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export interface Company {
  document_type: string
  document_number: string
  name: string
  id: string
  is_seller?: boolean
  is_buyer?: boolean
  is_legal_person?: boolean
  is_salesperson?: boolean
}

export interface CompanyBank {
  ispb: string
  account_number: string
  account_type: string
  account_digit: string
  branch_code: string
}

export interface CompanyNew {
  name: string
  document_type: string
  document_id: string
  street_address: string
  district: string
  city: string
  state: string
  zip_code: string
  email: string
  mobile_phone: string
  bank_account: CompanyBank
}

export enum CompanyType {
  Seller = 'seller',
  Supplier = 'seller',
  // TODO Desktop-v2: Substituir as refs de Buyer e por Merchant
  Buyer = 'buyer',
  Merchant = 'buyer',
  Salesperson = 'salesperson',
}

export interface Companies {
  companies: Company[]
}

export interface CompanyRegister {
  document_number: string
}
